import { AfterViewInit, Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, QueryList, Renderer2, ViewChild, ViewChildren } from "@angular/core";
import { NgControl } from "@angular/forms";
import { MatFormFieldControl } from "@angular/material/form-field";
import { Observable } from "rxjs";

@Component({
    selector: 'scale-rater',
    templateUrl: './scale-rater.component.html',
    styleUrls: ['./scale-rater.component.css'],
    providers: [{ provide: MatFormFieldControl, useExisting: ScaleRaterComponent }],
    standalone: false
})
export class ScaleRaterComponent implements MatFormFieldControl<number>, OnInit, AfterViewInit {
  @Input() public numberOfValues: number = 10;
  @Input() public value: number = 0;
  @Input() public interval: number = 1;
  @Input() public disabled: boolean;
  @Input() public showTicks: boolean = true;
  @Input() public startLabel: string = "Poor";
  @Input() public endLabel: string = "High";
  @Input() public mediumLimit: number = 4;
  @Input() public highLimit: number = 7;

  @Output() public valueChange = new EventEmitter<number>();
  public values: number[];
  public widthOfInterval: string;
  public incrementSizeStyle: any;

  @ViewChild("slider", { static: true }) slider: ElementRef;
  @ViewChildren("progress") progress: QueryList<ElementRef>;

  /*unused mat-field-control members*/
  stateChanges: Observable<void> = new Observable<void>();
  id: string;
  placeholder: string;
  ngControl: NgControl;
  focused: boolean;
  empty: boolean;
  shouldLabelFloat: boolean = true;
  required: boolean;
  errorState: boolean;
  controlType?: string;
  autofilled?: boolean;
  setDescribedByIds(ids: string[]): void {
  }
  onContainerClick(event: MouseEvent): void {
  }
  /*unused mat-field-control members*/


  constructor(
    private renderer: Renderer2
  ) {
    this.values = Array(this.numberOfValues).fill(this.interval).map((x, i) => i + 1);
  }

  ngOnInit(): void {
    if (this.disabled) {
      this.showTicks = false;
    }
    this.widthOfInterval = 100 / this.numberOfValues + '%';
    this.incrementSizeStyle = {
      'paddingLeft': ((100 / this.numberOfValues) / 2) + '%;',
      'paddingRight': ((100 / this.numberOfValues) / 2) + '%;'
    }
  }
  
  ngAfterViewInit(): void {
    if(this.value != 0){
      this.register(this.value);
    }
  }

  public setValue(incomingValue: number) {
    if (this.disabled) {
      return;
    }
    this.setValueInternal(incomingValue);
  }

  public setValueInternal(incomingValue: number) {

    this.value = incomingValue;
    this.valueChange.emit(this.value);

    let btns = this.progress.toArray();
    for (let i = 0; i < btns.length; i++) {
      this.renderer.removeClass(btns[i].nativeElement, 'marker');
    }
    this.renderer.addClass(btns[this.value - 1].nativeElement, 'marker');
    this.renderer.removeClass(this.slider.nativeElement, 'slider--undefined');
  }

  public buttonClass(value: number): string {
    if (this.value === value) {
      return 'current';
    } else {
      return '';
    }
  }

  public mouseEnter(b: any) {
    if (this.disabled) {
      return;
    }
    this.register(b);
  }

  public mouseLeave(b: number) {
    if (this.disabled) {
      return;
    }
    this.blur(b);
  }

  public register(b: any) {
    
    let btns = this.progress.toArray();

    for (let i = 0; i < btns.length; i++) {
      this.renderer.removeClass(btns[i].nativeElement, 'on');
      this.renderer.removeClass(btns[i].nativeElement, 'current');
    }

    for (let i = 0; i < b - 1; i++) {
      this.renderer.addClass(btns[i].nativeElement, 'on');
    }

    if (this.value > 0 && b != this.value) {
      this.renderer.addClass(btns[this.value - 1].nativeElement, 'marker');
    }

    this.renderer.addClass(btns[b - 1].nativeElement, 'current');

    let ragClass = 'low';
    if (b >= this.mediumLimit) {
      ragClass = 'med';
    }
    if (b >= this.highLimit) {
      ragClass = 'high';
    }
    this.renderer.removeClass(this.slider.nativeElement, 'low');
    this.renderer.removeClass(this.slider.nativeElement, 'med');
    this.renderer.removeClass(this.slider.nativeElement, 'high');
    this.renderer.addClass(this.slider.nativeElement, ragClass);
  }


  public blur(b: number) {
    if (this.disabled) {
      return;
    }
    
    let btns = this.progress.toArray();
    if (btns) {
      for (let i = 0; i < btns.length; i++) {
        this.renderer.removeClass(btns[i].nativeElement, 'on');
        this.renderer.removeClass(btns[i].nativeElement, 'current');
        this.renderer.removeClass(btns[i].nativeElement, 'marker');
      }
    }

    for (let i = 0; i < this.value - 1; i++) {
      this.renderer.addClass(btns[i].nativeElement, 'on');
    }
    if (this.value > 0) {
      this.renderer.addClass(btns[this.value - 1].nativeElement, 'current');
    }

    let ragClass = 'low';
    if (this.value >= 4) {
      ragClass = 'med';
    }
    if (this.value >= 7) {
      ragClass = 'high';
    }
    this.renderer.removeClass(this.slider.nativeElement, 'low');
    this.renderer.removeClass(this.slider.nativeElement, 'med');
    this.renderer.removeClass(this.slider.nativeElement, 'high');
    this.renderer.addClass(this.slider.nativeElement, ragClass);
  }

}
